import { HeroSection } from "@/components/landing/HeroSection";
import { FeaturesSection } from "@/components/landing/FeaturesSection";
import { CalculationsSection } from "@/components/landing/CalculationsSection";
import { DisciplinesSection } from "@/components/landing/DisciplinesSection";
import { CTASection } from "@/components/landing/CTASection";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CalculationsSection />
        <DisciplinesSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
